import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from "@material-ui/core";

const OwnerInfoDialog = ({isOpen = false, onClose, owner}) => {


  const rows = [
    { label: "Imię i nazwisko", value : owner.firstName + " " + owner.lastName },
    { label: "E-mail", value : owner.email },
    { label: "Telefon", value : owner.phone },
    { label: "Oddział", value : owner.name },
    { label: "Kod", value : owner.code },
  ];


  return (
      <Dialog onClose={onClose} aria-labelledby="customized-dialog-title" open={isOpen}>
        <DialogTitle id="customized-dialog-title" onClose={onClose}>
          Dane opiekuna oferty
        </DialogTitle>
        <DialogContent dividers>
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.label}>
                    <TableCell component="th" scope="row">
                      <strong>{row.label}</strong>
                    </TableCell>
                    <TableCell align="right">{row.value}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={onClose} color="primary">
            Zamknij
          </Button>
        </DialogActions>
      </Dialog>
      )

}

export default OwnerInfoDialog;
